module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.8ee235ee.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.ttf
// module id = 362
// module chunks = 3